import { PENDING, FULFILLED, REJECTED } from "redux-promise-middleware";
import {
  FETCH_RATE_LIMITS,
  FETCH_RATE_LIMIT,
  CREATE_RATE_LIMIT,
  UPDATE_RATE_LIMIT,
  DELETE_RATE_LIMIT
} from "../actions/rateLimit";

const SINGLE_DATA_INITIAL_STATE = {
  data: {},
  error: null,
  loading: false
};
const MULTI_DATA_INITIAL_STATE = {
  data: [],
  error: null,
  loading: false
};

export function rateLimits(state = MULTI_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${FETCH_RATE_LIMITS}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_RATE_LIMITS}_${FULFILLED}`:
      return Object.assign({}, state, payload.data, {
        loading: false,
        error: null
      });
    case `${FETCH_RATE_LIMITS}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function rateLimit(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${FETCH_RATE_LIMIT}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_RATE_LIMIT}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${FETCH_RATE_LIMIT}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function createPermission(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${CREATE_RATE_LIMIT}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${CREATE_RATE_LIMIT}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${CREATE_RATE_LIMIT}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function updatePermission(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${UPDATE_RATE_LIMIT}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${UPDATE_RATE_LIMIT}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${UPDATE_RATE_LIMIT}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function deletePermission(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${DELETE_RATE_LIMIT}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${DELETE_RATE_LIMIT}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${DELETE_RATE_LIMIT}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/rateLimit.js